import styled, { css } from 'styled-components';

const shouldForwardProp = prop =>
  !['variant', 'color', 'size', 'disabled', 'imgLoc', 'fullWidth'].includes(prop);

const getSizeStyles = size => {
  switch (size) {
    case 'large':
      return `
        padding: 10px 24px;
        font-family: "Pretendard";
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        gap : 8px;
      `;
    case 'medium':
      return `
        padding: 10px 24px;
        font-family: "Pretendard";
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        height : 44px;
      `;
    case 'small':
      return `
        padding: 8px 16px;
        font-family: "Pretendard";
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      `;
    case 'xSmall':
      return `
        padding: 6px 10px;
        font-family: "Pretendard";
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        border-radius: 6px;
        gap : 5px;
      `;
    case 'xxSmall':
      return `
        padding: 3px 15px;
        font-family: "Pretendard";
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        border-radius: 6px;
      `;
    case 'previous':
      return `
        padding: 6px 20px;
        font-family: "Pretendard";
  font-size: 14px;
  font-style: normal;
font-weight: 700;
line-height: 16px;
      `;

    default:
      return '';
  }
};

const getVariantStyles = (variant, color, disabled) => {
  if (variant === 'contained') {
    switch (color) {
      case 'primary':
        return `
          background: var(--Primary-500);
          border: 1px solid var(--Primary-500);
          color: #FFFFFF;
          ${
            !disabled
              ? `
            &:hover { background: var(--Primary-600); box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); }
            &:focus { box-shadow: 0px 0px 0px 2px #FE5493; }
            &:active { background: var(--Primary-700); box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); }
          `
              : `
            background: var(--GrayScale-200);
            border: 1px solid var(--GrayScale-200);
            color: #999999;
          `
          }
        `;
      case 'secondary':
        return `
          background: var(--Primary-50);
          border: 1px solid var(--Primary-50);
          color: var(--Primary-500);
          ${
            !disabled
              ? `
            // &:hover { background: #0063CF; box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); color: #FFFFFF; }
            // &:focus { box-shadow: 0px 0px 0px 2px #FE5493; }
            // &:active { background: #003C7E; box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); color: #FFFFFF; }
          `
              : `
            background: var(--GrayScale-200);
            border: 1px solid var(--GrayScale-200);
            color: #999999;
          `
          }
        `;
      case 'gray':
        return `
            background: var(--GrayScale-200);
            color: #191919;
     
          `;
      case 'kakao':
        return `
            background: #FEE500;
            color: #191919;
     
          `;
      case 'tertiary':
        return `
          background: none;
          color: #007AFF;
          ${
            !disabled
              ? `
            &:hover { background: #F5F5F5; color: #0063CF; }
            &:focus { border: 1px solid #FE5493; }
            &:active { color: #003C7E; }
          `
              : `
            color: #999999;
          `
          }
        `;
      case 'solidPink':
        return `
          background: #F43F5E;
          color: #FFFFFF;
          ${
            !disabled
              ? `
            &:hover { background: #E11D48; }
            &:focus { border: 1px solid #FE5493; }
            &:active { background: #9F1239; }
          `
              : `
            color: #999999;
          `
          }
        `;
      case 'solidPinkBonus':
        return `
          background: var(--Error-50);
          border: 1px solid var(--Error-50);
          color: #F43F5E;
          ${
            !disabled
              ? `
            &:hover { background: #E11D48; color: var(--gray-scale-0, #FFF); border: 1px solid #E11D48; }
            &:focus { border: 1px solid #FE5493; }
            &:active { background: #9F1239; border: 1px solid #9F1239; }
          `
              : `
            color: #999999;
          `
          }
        `;
      case 'white':
        return `
            background: var(--GrayScale-0);
            border: 1px solid var(--GrayScale-0);
            color: var(--Primary-500);
              `;
      case 'sub':
        return `
          border-radius: 8px;
          background: #FFFFFF;
          color: var(--Primary-500);
          border: 1px solid var(--Primary-500);
          font-weight: 500;
          ${
            !disabled
              ? `
            // &:hover { background: #EFF7FF; color: var(--Primary-500); border: 1px solid var(--Primary-500); }
            // &:focus { border: 1px solid #FE5493; }
            // &:active { background: var(--Primary-100); color: var(--Primary-100); }
          `
              : `
            border: 1px solid #999999;
            color: #999999;
          `
          }
        `;
      case 'pink':
        return `
          background: #FFE4E6;
          color: #F43F5E;
          border: 1px solid #FFE4E6;
          ${
            !disabled
              ? `
            &:hover { background: #FECDD3; border: 1px solid #FECDD3; }
            &:focus { border: 2px solid #FE5493; }
            &:active { background: #F43F5E; box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); color: #FFFFFF; }
          `
              : `
            background: #EDEDED;
            color: #999999;
          `
          }
        `;
      default:
        return '';
    }
  } else if (variant === 'outline') {
    switch (color) {
      case 'primary':
        return `
          border: 1px solid var(--Primary-500);
          background: var(--GrayScale-0);
          color: var(--Primary-500);
          ${
            !disabled
              ? `
            &:hover { background: var(--Primary-50); box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15); }
            &:focus { background: var(--GrayScale-0); box-shadow: 0px 0px 0px 2px #FE5493; }
            &:active { background: var(--Primary-100); border: 1px solid var(--Primary-700); }
          `
              : ''
          }
        `;
      case 'pinkBonus':
        return `
          background: #FFFFFF;
          border: 1px solid #FDA4AF;
          color: #F43F5E;
          ${
            !disabled
              ? `
            &:hover { background: #FFF1F2; color: var(--error-500, #F43F5E); border: 1px solid #F43F5E; }
            &:active { background: #FFE4E6; color: var(--error-500, #BE123C); border: 1px solid #BE123C; }
          `
              : `
            color: #999999;
          `
          }
        `;
      case 'gray':
        return `
          border: 1px solid var(--GrayScale-400);
          background: #FFFFFF;
          color: var(--GrayScale-900);
         
        `;
      case 'white':
        return `
            border: 1px solid #FFFFFF;
            background: #FFFFFF;
            color: var(--Primary-500);
           
          `;
      case 'modalgray':
        return `
          border: 1px solid #dddddd;
          background: #FFFFFF;
          color: #333333;
          ${
            !disabled
              ? `
            &:hover { background: var(--Primary-50); border: 1px solid var(--Primary-500); color: var(--Primary-500); }
          `
              : `
            color: #999999;
          `
          }
        `;
      default:
        return `
          border: 1px solid #DDDDDD;
          background: #FFFFFF;
          &:hover { background: #f5f5f5; }
        `;
    }
  }
  return '';
};
export const ButtonStyled = styled.button.withConfig({ shouldForwardProp })`
  box-sizing: border-box !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  gap: 10px;
  border: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  ${props => {
    const { variant, size, imgLoc, disabled, color } = props;
    return css`
      ${imgLoc === 'left' && 'flex-direction: row-reverse;'}
      ${getSizeStyles(size)}
      ${getVariantStyles(variant, color, disabled)}
    `;
  }}
`;

const getIconVariantStyles = (variant, color) => {
  if (variant === 'contained') {
    if (color === 'primary') {
      return `
        background: var(--Primary-500);
      `;
    }
    if (color === 'primaryLight') {
      return `
        background: #F4F3FF;
      `;
    }
  } else if (variant === 'outline') {
    if (color === 'primary') {
      return `
        background: var(--GrayScale-0);
        border: 1px solid var(--Primary-500);
      `;
    }
    if (color === 'gray') {
      return `
        background: var(--GrayScale-0);
        border: 1px solid var(--GrayScale-400);
      `;
    }
    if (color === 'white') {
      return `
        background: #ffffff;
        border: 1px solid #ffffff;
        color: var(--Primary-500);
      `;
    }
  }
  return '';
};

const getIconSizeStyles = size => {
  switch (size) {
    case 'large':
      return `
          padding: 12px 32px;
          font-family: "Pretendard";
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
      `;
    case 'medium':
      return `
          padding: 10px;
          font-family: "Pretendard";
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
      `;
    case 'small':
      return `
          padding: 4px;
          font-family: "Pretendard";
          font-weight: 800;
          font-size: 14px;
          line-height: 16px;
      `;
    case 'xSmall':
      return `
          padding: 6px 20px;
          font-family: "Pretendard";
          font-weight: 800;
          font-size: 14px;
          line-height: 16px;
        `;
    default:
      return '';
  }
};

export const IconButtonStyled = styled.button.withConfig({ shouldForwardProp })`
  display: inline-flex;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  outline: none;

  ${props => {
    const { variant, size, imgLoc, disabled, color } = props;
    let styles = '';

    if (imgLoc === 'left') {
      styles += 'flex-flow: row-reverse;';
    }

    return css`
      ${styles}
      ${getIconVariantStyles(variant, color)}
      ${getIconSizeStyles(size)}
    `;
  }}
`;
